/**
 * Maps publisher names (as they appear in projects.json) to icon filenames
 * stored in public/icons/publishers/.
 */
export const publisherIcons: Record<string, string> = {
  "Microsoft": "microsoft.png",
  "Microsoft Corporation": "microsoft.png",
  "Electronic Arts": "electronic-arts.png",
  "Adobe": "adobe.png",
  "Anysphere": "anysphere.png",
  "Xbox Game Studios": "xbox-game-studios.png",
  "Xbox Games Studios": "xbox-game-studios.png",
  "Microsoft Studios": "xbox-game-studios.png",
  "Ubisoft": "ubisoft.svg",
  "UBISOFT": "ubisoft.svg",
  "Activision": "activision.png",
  "Bethesda Softworks": "bethesda-softworks.png",
  "Bethesda": "bethesda-softworks.png",
  "Cisco": "cisco.png",
  "Google": "google.png",
  "Blizzard Entertainment": "blizzard-entertainment.png",
  "Paradox Interactive": "paradox-interactive.png",
  "Paradox": "paradox-interactive.png",
  "SEGA": "sega.png",
  "Sega": "sega.png",
  "SEGA Corporation": "sega-corporation.png",
  "Valve": "valve.png",
  "2K Games": "2k-games.png",
  "2K": "2k-games.png",
  "Samsung": "samsung.png",
  "Focus Entertainment": "focus-entertainment.png",
  "Amazon": "amazon.png",
  "Amazon Games": "amazon.png",
  "Apple": "apple.png",
  "Larian Studios": "larian-studios.png",
  "Frontier Developments": "frontier-developments.png",
  "RockStar Games": "rockstar-games.png",
  "Rockstar Games": "rockstar-games.png",
  "Lenovo": "lenovo.png",
  "BANDAI NAMCO Entertainment": "bandai-namco-entertainment.png",
  "Bandai Namco": "bandai-namco-entertainment.png",
  "Bandi Namco": "bandai-namco-entertainment.png",
  "Warner Bros. Interactive Entertainment": "warner-bros.png",
  "WB Games": "warner-bros.png",
  "Square Enix": "square-enix.png",
  "Square Enix Ltd.": "square-enix.png",
  "Codemasters": "codemasters.png",
  "Dropbox": "dropbox.png",
  "Meta": "meta.png",
  "Zoom": "zoom.png",
  "Tencent": "tencent.png",
  "Mozilla": "mozilla.png",
  "Opera": "opera.png",
  "Oracle": "oracle.png",
  "Epic Games": "epic-games.png",
  "Epic Games Inc.": "epic-games.png",
  "Discord": "discord.png",
  "Riot Games": "riot-games.png",
  "Riot": "riot-games.png",
  "Spotify": "spotify.png",
  "Netflix": "netflix.png",
  "Notion": "notion.png",
  "Open AI": "open-ai.png",
  "Anthropic": "anthropic.png",
  "Salesforce": "salesforce.png",
  "Snap Inc.": "snap-inc.png",
  "Telegram": "telegram.png",
  "Signal Foundation": "signal-foundation.png",
  "HP": "hp.png",
  "Dell": "dell.png",
  "Capcom": "capcom.png",
  "CAPCOM Co., Ltd.": "capcom.png",
  "CAPCOM Co. Ltd.": "capcom.png",
  "CD Projekt Red": "cd-projekt-red.png",
  "ROBLOX Corporation": "roblox.png",
  "Roblox Entertainment": "roblox.png",
  "Steam": "steam.png",
  "ByteDance": "bytedance.png",
  "EA Games": "electronic-arts.png",
  "EA": "electronic-arts.png",
};
